var render = function render(){var _vm=this,_c=_vm._self._c;return _c('json-viewer',{staticStyle:{"height":"100%"},attrs:{"value":_vm.data ? _vm.data : {},"expand-depth":5,"copyable":"","boxed":"","sort":"","theme":_vm.$vuetify.theme.dark ? 'my-awesome-json-theme-dark' : 'my-awesome-json-theme-light'},on:{"keyclick":_vm.keyClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }